module.exports = __webpack_public_path__ + "static/media/empty_tasks_desktop.34102c53.png";